<p-panel
  [styleClass]="'no-padding-panel panel-shadow'"
  id="jobHistorys"
  [ngClass]="{
    'history-timeline-panel': organisationTypeId != 2,
    'history-timeline-panel-customer': organisationTypeId == 2
  }"
>
  <p-header>
    <div class="panel-header">
      <div class="flex">
        <div class="flex-grow-1">Job History</div>
        <div class="flex-shrink-1">
          <span (click)="loadHistorys()" class="cursor-pointer refresh-text"
            ><i class="fa fa-undo"></i>&nbsp;Refresh</span
          >
        </div>
      </div>
      <div class="flex filter-line grid-gap-15 mt-1 align-items-center flex-wrap">
        <div class="flex-grow-1">
          <div class="input-group">
            <div class="input-group-item">
              <p-dropdown
                appendTo="body"
                id="eventType"
                class="filter-dropdown input-group-filter dropdown-narrow-2 w-100"
                placeholder="All Event Types"
                (onChange)="filterEventTypeChanged()"
                [options]="eventTypes"
                [(ngModel)]="selectedEventType"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div class="flex-grow-1" sytle="flex-basis: 50px;">
          <input
            pInputText
            placeholder="Search history"
            class="w-100 search-history-filter"
            [(ngModel)]="filterHistorySearch"
            (keyup)="filterEventTypeChanged()"
          />
        </div>
        <div class="flex grid-gap-15 text-right">
          <p-checkbox
            binary="true"
            (onChange)="filterEventTypeChanged()"
            label="Engineius"
            [(ngModel)]="filterEngineius"
            styleClass="on-dark-background"
          ></p-checkbox>

          <p-checkbox
            binary="true"
            (onChange)="filterEventTypeChanged()"
            label="Customer"
            [(ngModel)]="filterCustomer"
            styleClass="on-dark-background"
          ></p-checkbox>

          <p-checkbox
            binary="true"
            (onChange)="filterEventTypeChanged()"
            label="Supplier"
            [(ngModel)]="filterSupplier"
            styleClass="on-dark-background"
          ></p-checkbox>
        </div>
      </div>
    </div>
  </p-header>

  <p-progressBar
    *ngIf="isLoading"
    mode="indeterminate"
    class="ui-progressbar-indeterminate"
  ></p-progressBar>

  <div class="flex flex-column" style="height:{{ panelHeight }}">
    <div style="flex-grow: 1; overflow-y: scroll">
      <div
        *ngIf="historys.length == 0 && !isLoading"
        class="flex align-items-center"
        style="height: 100%"
      >
        <div
          class="no-notes flex-grow-1"
          style="text-align: center; color: #bbb; font-weight: 600; font-size: 30px"
        >
          No Notes
        </div>
      </div>

      <div class="history-container" *ngFor="let history of historys">
        <div class="ui-g">
          <div class="ui-g-4 event-left" style="display: flex; align-items: center; grid-gap: 15px">
            <div style="flex-grow: 1">
              <span class="event-time" pTooltip="{{ history.created }}">{{
                history.created | datex : "ddd DD MMM 'YY HH:mm"
              }}</span>
              <div class="history-organisation">&bull; {{ history.organisation }}</div>
            </div>
            <div style="flex-shrink: 1; width: 30px; height: 30px">
              <img
                alt=""
                style="width: 30px"
                src="assets/images/jobhistory/{{ history.tagType }}.png"
                [pTooltip]="history.area"
              />
            </div>
          </div>
          <div class="ui-g-8">
            <div style="display: flex; align-items: center">
              <div style="flex-grow: 1">
                <div style="padding-right: 10px">
                  <div class="event-owner" pTooltip="{{ history.user }}">
                    {{ history.userFullName }}
                  </div>
                  <div class="event-text">{{ history.description }}</div>
                </div>
              </div>
              <div style="flex: 0 0 130px">
                <div *ngIf="history.taskName" class="event-task-name">
                  {{ getRegPlate(history.taskName) }}
                </div>
                <div class="event-area">{{ history.area }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="event-actions" *ngIf="organisationTypeId != OrganisationTypeEnum.Supplier">
      <div class="flex mt-1 grid-gap-15 align-items-center">
        <div style="font-weight: 600">New Note</div>
        <div>
          <p-multiSelect
            appendTo="body"
            class="filter-multiselect input-group-filter multiselect-narrow-1 w-100"
            placeholder="All Tasks"
            (onChange)="setTasksChosen($event)"
            [options]="taskOptions"
            [(ngModel)]="tasksChosen"
          ></p-multiSelect>
        </div>
      </div>

      <div class="event-note-container">
        <textarea
          class="event-note-area"
          [(ngModel)]="newHistoryNote"
          [maxlength]="750"
          style="padding: 10px"
          autocomplete="off"
          placeholder="Type new note.."
          autocapitalize="off"
          spellcheck="false"
          pInputTextarea
        ></textarea>
      </div>

      <div class="event-checkbox-container" style="display: flex; width: 100%; flex-wrap: wrap">
        <div
          *ngIf="organisationTypeId == 1"
          class="flex-grow-1 flex grid-gap-10 pt-2 align-items-center flex-wrap"
        >
          <div style="font-weight: 500">Who should see this note:</div>

          <div class="flex grid-gap-15">
            <div class="event-type-checkbox">
              <p-checkbox
                [(ngModel)]="newNoteIsEngineius"
                binary="true"
                [labelStyleClass]="'ml-0'"
                label="Engineius"
              ></p-checkbox>
            </div>
            <div class="event-type-checkbox">
              <p-checkbox
                [(ngModel)]="newNoteIsCustomer"
                binary="true"
                [labelStyleClass]="'ml-0'"
                label="Customer"
              ></p-checkbox>
            </div>
            <div class="event-type-checkbox">
              <p-checkbox
                [(ngModel)]="newNoteIsSupplier"
                binary="true"
                [labelStyleClass]="'ml-0'"
                label="Supplier"
              ></p-checkbox>
            </div>
          </div>
        </div>
        <div class="flex-grow-1 text-right">
          <button
            type="button"
            (click)="addNewNote()"
            pButton
            label="Add Note"
            class="ui-button event-note-add-button ui-button-primary btn-mobile-block"
            [disabled]="
              !newHistoryNote ||
              (organisationTypeId == 1 &&
                !newNoteIsEngineius &&
                !newNoteIsCustomer &&
                !newNoteIsSupplier)
            "
          ></button>
        </div>
      </div>
    </div>
  </div>
</p-panel>
